import React, { useEffect, useState } from "react";
import { Card, Typography, Descriptions, Spin } from "antd";
import { useParams } from "react-router-dom";
import axios from "axios";

const { Title, Paragraph } = Typography;

const FAQDetails = () => {
  const { id } = useParams();
  const [faq, setFaq] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchFAQ();
  }, [id]);

  const fetchFAQ = async () => {
    try {
      const response = await axios.get(`http://93.127.203.113:5005/faqs/${id}`);
      setFaq(response.data);
    } catch (error) {
      console.error("Error fetching FAQ:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      {loading ? (
        <Spin size="large" />
      ) : (
        <Card style={styles.card}>
          <Title level={3} style={styles.title}>
            FAQ Details
          </Title>
          <Descriptions bordered column={1} style={{ marginTop: "20px" }}>
            <Descriptions.Item label="Question" style={styles.label}>
              <Paragraph strong>{faq.question}</Paragraph>
            </Descriptions.Item>
            <Descriptions.Item label="Answer" style={styles.label}>
              <Paragraph>{faq.answer}</Paragraph>
            </Descriptions.Item>
          </Descriptions>
        </Card>
      )}
    </div>
  );
};

// 🎨 **Styled Components**
const styles = {
  container: {
    padding: "40px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "80vh",
  },
  card: {
    width: "80%",
    maxWidth: "700px",
    borderRadius: "10px",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
    padding: "20px",
    textAlign: "center",
  },
  title: {
    color: "#0c8c49",
    marginBottom: "20px",
  },
  label: {
    fontSize: "16px",
    fontWeight: "bold",
    background: "#f9f9f9",
  },
};

export default FAQDetails;
